/**
 * Get value or resolve the value from callable.
 * @param {*} val
 * @return {*}
 */
export function value(val) {
  if (typeof val === 'function') {
    return val();
  }

  return val;
}

/**
 * Get object size.
 * @param {Array|Object} object
 * @returns {number}
 */
export function getSize(object) {
  if (!object) {
    return 0;
  }

  if (Array.isArray(object)) {
    return object.length;
  }

  return Object.keys(object).filter(key => object.hasOwnProperty(key)).length;
}

/**
 * Make sure the value is an array, if not, wrap it into an array.
 * @param {*} value
 * @returns {Array}
 */
export function asArray(data) {
  if (Array.isArray(data)) {
    return data;
  }

  return [data];
}

/**
 * Generator for iterating array or object.
 * @param {Array|Object} object
 */
export function *makeIterator(object) {
  if (Array.isArray(object)) {
    const arrayLength = object.length;
    for (let i = 0; i < arrayLength; i++) {
      yield { key: i, value: object[i] };
    }
  } else {
    for (const key in object) {
      if (!object.hasOwnProperty(key)) {
        continue;
      }

      yield { key, value: object[key] };
    }
  }
}

/**
 * Determine if objects have the same key values. Shallow comparison.
 * @param {Object} a
 * @param {Object} b
 * @return {boolean}
 */
export function isShallowEqual(a, b) {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) {
    return false;
  }

  return aKeys.every(key => String(a[key]) === String(b[key]));
}

/**
 * Convert object to FormData.
 * @param {*} obj
 * @param {?string} namespace
 * @param {?FormData} form
 * @returns {FormData}
 */
export function toFormData(obj, namespace = undefined, form = undefined) {
  const fd = form || new FormData();
  // eslint-disable-next-line no-useless-assignment
  let formKey = null;

  for (const property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = `${namespace}[${property}]`;
      } else {
        formKey = property;
      }

      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString());
      } else if (typeof obj[property] === 'object' && !(obj[property] instanceof File) && !(obj[property] instanceof Blob)) {
        toFormData(obj[property], formKey, fd);
      } else {
        fd.append(formKey, obj[property]);
      }
    }
  }

  return fd;
}

